import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function t(a, e) {
  return o(), l("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.938 2.857A8.2 8.2 0 0 0 11.273 2a8.2 8.2 0 0 0-7.178 4.218 8.21 8.21 0 0 0-.02 7.946l-1.998 4.199a.796.796 0 0 0 1.06 1.06l4.194-2a8.21 8.21 0 0 0 11.855-4.953 8.23 8.23 0 0 0-4.248-9.613M7.915 4.502a6.6 6.6 0 0 1 3.357-.911h.002a6.62 6.62 0 0 1 5.295 2.63 6.63 6.63 0 0 1-5.903 10.598 6.6 6.6 0 0 1-2.877-.97.8.8 0 0 0-.762-.043l-2.551 1.216 1.215-2.554a.8.8 0 0 0-.043-.762 6.62 6.62 0 0 1 2.267-9.204m-1.382 4.55a1.456 1.456 0 0 1 2.022 2.022 1.458 1.458 0 1 1-2.022-2.023m3.886 0a1.456 1.456 0 0 1 2.021 2.022 1.457 1.457 0 1 1-2.02-2.023m4.696-.246a1.456 1.456 0 0 0-1.43 1.742 1.459 1.459 0 0 0 2.641.526 1.46 1.46 0 0 0-1.211-2.268",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const m = { render: t };
export {
  m as default,
  t as render
};
